import React from 'react';
import { Card, CardContent, Badge, Button } from '@ncoder/ui';
import { FileText } from 'lucide-react';

interface DatasetCardProps {
  name: string;
  size: string;
  records: number;
  status: 'processed' | 'processing' | 'pending';
  quality: number;
  onView?: () => void;
  onEdit?: () => void;
}

export const DatasetCard: React.FC<DatasetCardProps> = ({
  name,
  size,
  records,
  status,
  quality,
  onView,
  onEdit,
}) => {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg">
              <FileText className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h3 className="font-semibold">{name}</h3>
              <p className="text-sm text-muted-foreground">
                {records.toLocaleString()} records • {size}
              </p>
              <div className="flex items-center gap-2 mt-1">
                <Badge variant={status === 'processed' ? 'default' : 'secondary'}>
                  {status}
                </Badge>
                <span className="text-xs text-muted-foreground">
                  Quality: {quality}%
                </span>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={onView}>
              View
            </Button>
            <Button variant="outline" size="sm" onClick={onEdit}>
              Edit
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
